/* =====================================================================
   LP TEMPLATE — interacțiuni
   Fără dependențe. Fiecare bloc e independent: șterge ce nu folosești.
   ===================================================================== */
(function () {
  "use strict";
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (n) => "$" + n.toFixed(2);

  /* ---------- 1. Countdown din bara de anunț ----------
     Pornește de la durata din data-duration (secunde) și persistă per vizitator
     în localStorage, ca să nu se reseteze la fiecare refresh. */
  (function countdown() {
    const el = $("[data-countdown]");
    if (!el) return;
    const total = parseInt(el.dataset.duration || "10283", 10); // 02:51:23 implicit
    const key = "lp_countdown_end";
    let end = 0;
    try { end = parseInt(localStorage.getItem(key) || "0", 10); } catch (e) {}
    if (!end || end < Date.now()) {
      end = Date.now() + total * 1000;
      try { localStorage.setItem(key, String(end)); } catch (e) {}
    }
    const hh = $(".cd-hh", el), mm = $(".cd-mm", el), ss = $(".cd-ss", el);
    const pad = (n) => String(n).padStart(2, "0");
    const tick = () => {
      let s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      hh.textContent = pad(Math.floor(s / 3600));
      mm.textContent = pad(Math.floor((s % 3600) / 60));
      ss.textContent = pad(s % 60);
    };
    tick();
    setInterval(tick, 1000);
  })();

  /* ---------- 2. Galerie produs ---------- */
  (function gallery() {
    const gal = $("[data-gallery]");
    if (!gal) return;
    const slides = $(".gal__slides", gal);
    const thumbs = $$(".gal__thumb", gal);
    let i = 0;
    const go = (n) => {
      i = (n + thumbs.length) % thumbs.length;
      slides.style.transform = `translateX(-${i * 100}%)`;
      thumbs.forEach((t, k) => t.classList.toggle("is-active", k === i));
      thumbs[i].scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
    };
    thumbs.forEach((t, k) => t.addEventListener("click", () => go(k)));
    $(".gal__prev", gal).addEventListener("click", () => go(i - 1));
    $(".gal__next", gal).addEventListener("click", () => go(i + 1));
    // swipe pe mobil
    let x0 = null;
    slides.addEventListener("touchstart", (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    slides.addEventListener("touchend", (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    });
  })();

  /* ---------- 3. Selector de pachete (sincronizat între buy box și oferta de jos) ----------
     Fiecare .offer__card are data-qty, data-price (total), data-compare (total).
     Cadourile au data-unlock-qty = cantitatea minimă care le deblochează. */
  (function offers() {
    const groups = $$("[data-offer]");
    if (!groups.length) return;
    const select = (qty) => {
      let card;
      groups.forEach((g) => {
        $$(".offer__card", g).forEach((c) => {
          const on = c.dataset.qty === String(qty);
          c.classList.toggle("is-selected", on);
          $(".offer__btn", c).setAttribute("aria-pressed", on);
          if (on) card = c;
        });
      });
      if (!card) return;
      const price = parseFloat(card.dataset.price), compare = parseFloat(card.dataset.compare);
      const save = compare - price;
      $$("[data-price-main]").forEach((e) => (e.textContent = money(price)));
      $$("[data-price-compare]").forEach((e) => { e.textContent = money(compare); e.hidden = save <= 0; });
      $$("[data-price-save]").forEach((e) => { e.textContent = money(save); e.closest(".price__save").hidden = save <= 0; });
      $$(".gift").forEach((g) => g.classList.toggle("is-locked", qty < parseInt(g.dataset.unlockQty || "1", 10)));
    };
    groups.forEach((g) =>
      $$(".offer__card", g).forEach((c) => $(".offer__btn", c).addEventListener("click", () => select(c.dataset.qty)))
    );
    // click pe un cadou blocat → selectează pachetul care îl deblochează
    $$(".gift").forEach((g) =>
      g.addEventListener("click", () => { if (g.classList.contains("is-locked")) select(g.dataset.unlockQty); })
    );
    const initial = $(".offer__card.is-selected", groups[0]);
    select(initial ? initial.dataset.qty : $(".offer__card", groups[0]).dataset.qty);
  })();

  /* ---------- 4. Data de livrare („Ships by Thu, Sep 17") = mâine ---------- */
  (function shipDate() {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    const txt = d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
    $$("[data-ship-date]").forEach((e) => (e.textContent = txt));
  })();

  /* ---------- 5. Bara ATC lipicioasă: vizibilă DOAR când niciun buton „Add to cart" (data-atc) nu e pe ecran ----------
     rootMargin scade zona acoperită de bară, ca un buton ascuns sub ea să nu conteze ca „pe ecran". */
  (function sticky() {
    const bar = $("[data-sticky]"), atcs = $$("[data-atc]");
    if (!bar || !atcs.length) return;
    const visible = new Map();
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((en) => visible.set(en.target, en.isIntersecting));
      bar.classList.toggle("is-visible", ![...visible.values()].some(Boolean));
    }, { rootMargin: "0px 0px -" + bar.offsetHeight + "px 0px", threshold: 0.2 });
    atcs.forEach((a) => obs.observe(a));
  })();

  /* ---------- 6. Slider înainte/după ---------- */
  (function beforeAfter() {
    const root = $("[data-ba]");
    if (!root) return;
    const slides = $$(".ba__slide", root), dots = $$(".ba__dot", root);
    let i = 0;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => (s.hidden = k !== i));
      dots.forEach((d, k) => d.classList.toggle("is-active", k === i));
    };
    dots.forEach((d, k) => d.addEventListener("click", () => go(k)));
    $(".ba__arrow--prev", root).addEventListener("click", () => go(i - 1));
    $(".ba__arrow--next", root).addEventListener("click", () => go(i + 1));
    go(0);
  })();

  /* ---------- 7. Pași (timeline): un singur pas deschis; poza din dreapta = data-img al pasului ---------- */
  (function steps() {
    const steps = $$("[data-steps] .step");
    const side = $("[data-steps] .steps__img img");
    steps.forEach((s) =>
      $(".step__toggle", s).addEventListener("click", () => {
        const open = s.classList.contains("is-open");
        steps.forEach((o) => o.classList.remove("is-open"));
        if (!open) {
          s.classList.add("is-open");
          if (side && s.dataset.img) side.src = s.dataset.img;
        }
      })
    );
  })();

  /* ---------- 8. Slider ingrediente ---------- */
  (function ingredients() {
    const root = $("[data-ing]");
    if (!root) return;
    const track = $(".ing__track", root), cards = $$(".ing__card", root), pills = $$(".ing__pill", root);
    const prev = $(".ing__prev", root), next = $(".ing__next", root);
    let i = 0;
    const go = (n) => {
      i = Math.max(0, Math.min(cards.length - 1, n));
      const w = cards[0].getBoundingClientRect().width + 20;
      track.style.transform = `translateX(-${i * w}px)`;
      prev.disabled = i === 0;
      next.disabled = i === cards.length - 1;
      pills.forEach((p, k) => p.classList.toggle("is-active", k === i));
    };
    prev.addEventListener("click", () => go(i - 1));
    next.addEventListener("click", () => go(i + 1));
    pills.forEach((p, k) => p.addEventListener("click", () => go(k)));
    window.addEventListener("resize", () => go(i));
    go(0);
  })();

  /* ---------- 9. FAQ: o singură întrebare deschisă ---------- */
  (function faq() {
    const items = $$("[data-faq] .faq__item");
    items.forEach((item) =>
      $(".faq__toggle", item).addEventListener("click", () => {
        const open = item.classList.contains("is-open");
        items.forEach((o) => o.classList.remove("is-open"));
        if (!open) item.classList.add("is-open");
      })
    );
  })();

  /* ---------- 12. Popup scratch card: o dată per sesiune, la 1s după încărcare ---------- */
  (function promo() {
    const box = $("[data-promo]");
    if (!box) return;
    const key = "lp_promo_seen";
    try { if (sessionStorage.getItem(key)) return; } catch (e) {}
    const close = () => { box.hidden = true; try { sessionStorage.setItem(key, "1"); } catch (e) {} };
    $(".promo__close", box).addEventListener("click", close);
    box.addEventListener("click", (e) => { if (e.target === box) close(); });
    $(".promo__prize", box).textContent = box.dataset.prize || "";
    const cv = $(".promo__canvas", box), ctx = cv.getContext("2d");
    // strat auriu cu textul SCRATCH HERE
    const g = ctx.createLinearGradient(0, 0, 300, 150);
    g.addColorStop(0, "#c9a24a"); g.addColorStop(0.5, "#e6cd7a"); g.addColorStop(1, "#b8912f");
    ctx.fillStyle = g; ctx.fillRect(0, 0, 300, 150);
    ctx.fillStyle = "rgba(255,255,255,0.7)"; ctx.font = "700 26px Poppins, sans-serif";
    ctx.textAlign = "center"; ctx.textBaseline = "middle"; ctx.fillText("SCRATCH HERE", 150, 75);
    ctx.globalCompositeOperation = "destination-out";
    let down = false, cleared = 0;
    const pos = (e) => { const r = cv.getBoundingClientRect(); return [(e.clientX - r.left) * 300 / r.width, (e.clientY - r.top) * 150 / r.height]; };
    const scratch = (e) => {
      if (!down) return;
      const [x, y] = pos(e);
      ctx.beginPath(); ctx.arc(x, y, 18, 0, Math.PI * 2); ctx.fill();
      if (++cleared % 15 === 0) {
        const d = ctx.getImageData(0, 0, 300, 150).data; let t = 0;
        for (let i = 3; i < d.length; i += 4 * 8) if (d[i] === 0) t++;
        if (t / (d.length / 32) > 0.5) ctx.clearRect(0, 0, 300, 150); // dezvăluie tot după 50%
      }
    };
    cv.addEventListener("pointerdown", (e) => { down = true; scratch(e); });
    cv.addEventListener("pointermove", scratch);
    window.addEventListener("pointerup", () => (down = false));
    setTimeout(() => { box.hidden = false; }, 1000);
  })();

  /* ---------- 10. Recenzii: „Read more" ---------- */
  $$(".rev__more").forEach((a) =>
    a.addEventListener("click", (e) => {
      e.preventDefault();
      a.previousElementSibling.classList.remove("is-truncated");
    })
  );

  /* ---------- 11. Formulare demo: nu trimit nicăieri ---------- */
  $$("form[data-demo]").forEach((f) => f.addEventListener("submit", (e) => e.preventDefault()));

  /* ---------- 13. Țara vizitatorului: steag + cod, prin detecția Shopify ----------
     Pe Shopify, /browsing_context_suggestions.json întoarce țara detectată după IP.
     În afara Shopify (fișier local, artefact) rămâne valoarea implicită din HTML (RO). */
  (function country() {
    const codes = $$("[data-country]"), flags = $$("[data-country-flag]");
    if (!codes.length && !flags.length) return;
    fetch("/browsing_context_suggestions.json?country[enabled]=true", { credentials: "same-origin" })
      .then((r) => r.json())
      .then((d) => {
        const c = d && d.detected_values && d.detected_values.country;
        if (!c || !c.handle) return;
        codes.forEach((e) => (e.textContent = c.handle));
        flags.forEach((f) => { f.alt = c.name || c.handle; f.src = "https://flagcdn.com/w40/" + c.handle.toLowerCase() + ".png"; });
      })
      .catch(() => {});
  })();
})();
